import TypeAheadFilter from './TypeAheadFilter'

export default TypeAheadFilter



// WEBPACK FOOTER //
// ./src/modules/Filters/TypeAheadFilter/index.js